import type { JSX } from 'react'

export const DocumentIcon = (): JSX.Element => (
  <use href='#documentIcon' height='100%' width='100%' />
)
